import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@components/common';
import { CardNumberElement } from 'react-stripe-elements';
import styled from 'styled-components';
import theme from '@styles/theme';

const elementStyles = {
  base: {
    fontSize: `${theme.fontSizes[1]}px`
  }
};

const StyledField = styled(Box)`
  display: block;
  width: 100%;
  outline: none;
  border-radius: 4px;
  border-width: 0;
  margin-bottom: 16px;
  padding: 16px;
  font-size: 17px;
  border: 0;
  box-shadow: inset 0px 3px 5px 0px rgba(0, 0, 0, 0.1),
    inset 0px 0px 1px 1px rgba(0, 0, 0, 0.15);
`;

function StripeCardField(props) {
  const { field, form } = props;

  const handleChange = e => {
    form.setFieldValue(field.name, e.complete);
  };

  return (
    <StyledField>
      <CardNumberElement style={elementStyles} onChange={handleChange} />
    </StyledField>
  );
}

StripeCardField.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object
};

export default StripeCardField;
